<template>
  <!--
    Fixed-ratio wrapper that reserves the animation's box so the lazily loaded
    player does not shift layout when it upgrades. Every Lottie on the site is
    authored at 1500x1000 (3:2), so the ratio is fixed here and the player fills
    the wrapper. width:100% + aspect-ratio holds the exact final box from first
    paint (verified: 588x392 in these columns, matching the settled player), as
    long as the parent column has a real width. Brick's media column needed a
    w-full to stop it collapsing to content width; see that component.
  -->
  <div ref="wrapperEl" class="lottie-wrap" :class="wrapperClass">
    <dotlottie-player
    autoplay="true"
    loop="true"
    :src="src"
    class="lottie-wrap__player"
    />
  </div>
</template>

<script setup>
defineProps({
  src: {
    type: String,
    required: true,
  },
  // Classes applied to the ratio-holding wrapper (e.g. rounded corners),
  // matching where they used to sit on the bare player element.
  wrapperClass: {
    type: String,
    default: '',
  },
})

const wrapperEl = ref(null)
useDotLottie(wrapperEl)
</script>

<style scoped>
.lottie-wrap {
  width: 100%;
  aspect-ratio: 3 / 2;
}

/* The player fills the reserved box. Before it upgrades the custom element is
   inert and simply occupies the wrapper; after upgrade its :host takes 100%. */
.lottie-wrap__player {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
